import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocV2EntitiesUpdate extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Update Entities</h3>
                <code className="api-definition">
                    <span className="put-badge">PUT</span>&nbsp;{urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}id{'}'}
                </code>
                <div className="description">
                    <b>Update Knowledgebase Entity</b><br/>
                    <br/>
                    The entities PUT request updates an existing entity with the <i>entity_id</i> provided in the appropriate  
                    knowledgebase.<br/>
                    <br/>
                    A JSON object representing the updated entity is sent as the payload. 
                    Available <Link to="/documentation/doc_kbattributes">entity fields</Link> will vary by entity type.<br/>
                    <br/>
                    <div className="example-content host">
                        NOTE: This request completely replaces all entity data for the specified entity. It does not just update the provided 
                        fields, so a complete entity JSON object must be provided.
                    </div>
                    <br/>
                    A successful request returns a status code 200 (HTTP OK) and a JSON representation of the updated 
                    entity in the response body with its updated version.

                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3"> URL Parameters</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The Finch identifier for entity to update.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Request object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">label</td>
                        <td className="meaning">The typically used name of the entity.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">document</td>
                        <td className="meaning">A UTF-8 text document describing the entity. Document must be at least 256 chars.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">description</td>
                        <td className="meaning">A UTF-8 short description for the entity.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">prominence</td>
                        <td className="meaning">The news prominence of the entity. Decimal value in the range 0.0 to 1.0.</td>
                        <td className="type">Decimal</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">nameVariations</td>
                        <td className="meaning">An array of string values that represent common names used for the entity.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The unique identifier for the KB entity to update. 
                            Must match the entity id supplied in the request URL.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">userData</td>
                        <td className="meaning">A string representation of a JSON object containing user-defined 
                            attributes. The JSON object may contain nested objects and arrays, but must be valid JSON syntax.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>other fields</i></td>
                        <td className="meaning">Other fields may be provided that relate to the entity being updated.<br/>
                            <br/>
                            NOTE: All fields that were present in the original entity must be supplied in the 
                            update call, even those not being updated. This call will replace the original entity so any 
                            fields not supplied will be removed.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link>.</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>prohibited fields</i></td>
                        <td className="meaning">Fields that are generated during the update process that are not 
                            allowed to be present in the request object. If you copy an existing KB entity to use as 
                            a template for an entity being updated, you must remove these fields.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link></td>
                        <td className="constraints">Prohibited fields include:<br/>
                            <br/>
                            <i>newsTopics</i><br/>
                            <i>proximityContext</i><br/>
                            <i>personNames</i><br/>
                            <i>orgNames</i><br/>
                            <i>names</i><br/>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        PUT {urlHandler.API_ENDPOINT_V2_ENTITIES}/1142506930472551406<br/>
                        Accept: application/JSON<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                        {JSON.stringify(examples.EXAMPLE_REQUEST_V2_ENTITIES_UPDATE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The update entity response object contains a JSON representation of the updated entity in the 
                    response body with its updated version.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The unique identifier assigned to the new entity.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">version</td>
                        <td className="meaning">The version for the created entity.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>other fields</i></td>
                        <td className="meaning">Other fields may be provided that relate to the entity being updated.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link>.</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_V2_ENTITIES_UPDATE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Error Responses</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Code </th>
                        <th>Status Text </th>
                        <th>Description </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">404</td>
                        <td className="status-text">Not Found</td>
                        <td className="notes">Entity not found (another client deleted it).
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">409</td>
                        <td className="status-text">Conflict</td>
                        <td className="notes">Indicates a concurrency issue. The version of the entity sent in the request is 
                            older than the version found in the KB (i.e. someone else updated it).
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">423</td>
                        <td className="status-text">Locked</td>
                        <td className="notes">Indicates that the entity was in the process of being updated or deleted 
                            when the request was received.
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DocV2EntitiesUpdate;